import React from "react";
import { ThemeProvider } from "@mui/material";
import { Application } from "./pages/Application";
import { ApplicationProvider } from "./context/ApplicationContext";
import { customTheme } from "./theme/customTheme";
import IdleTimerContainer from "./components/IdleTimerContainer";

function App() {
  return (
    <ApplicationProvider>
      <ThemeProvider theme={customTheme}>
        <Application />
        <IdleTimerContainer />
      </ThemeProvider>
    </ApplicationProvider>
  );
}

export default App;
